/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 下载进度弹窗组件（公共）
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-01-28
 */

import React from 'react'
import { Modal, Progress } from 'antd'
import './DownloadProgressModal.scss'

export interface DownloadProgressModalProps {
  visible: boolean
  total: number
  current: number
  onCancel?: () => void
  title?: string
}

/**
 * 下载进度弹窗组件
 */
const DownloadProgressModal: React.FC<DownloadProgressModalProps> = ({
  visible,
  total,
  current,
  onCancel,
  title = '下载处理中...'
}) => {
  const percent = total > 0 ? Math.round((current / total) * 100) : 0
  const isCompleted = current >= total && total > 0

  return (
    <Modal
      open={visible}
      title={title}
      footer={null}
      closable={!isCompleted}
      mask={{ closable: false }}
      onCancel={onCancel}
      width={500}
      className="watermark-batch-editor-download-progress-modal"
    >
      <div className="download-progress-content">
        <Progress
          percent={percent}
          status={isCompleted ? 'success' : 'active'}
          format={() => `${percent}%`}
        />
      </div>
    </Modal>
  )
}

export default DownloadProgressModal
